import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreakpointState } from './state/breakpoint.state';
import { NgxsModule } from '@ngxs/store';



@NgModule({
  declarations: [],
  imports: [
    NgxsModule.forFeature([BreakpointState]),
    CommonModule
  ]
})
export class BreakpointModule { }
